import moment from "moment/moment";

export const calculateArrowAngles = (hourPos, minutePos) => {
  const hourAngle = (hourPos % 12) * 30 + (minutePos % 60) * 0.5;
  const minuteAngle = (minutePos % 60) * 6;

  return { hourAngle, minuteAngle };
};

export const getCurrentUtcTime = () => {
  const now = new Date();
  const utcHours = String(now.getUTCHours()).padStart(2, '0');
  const utcMinutes = String(now.getUTCMinutes()).padStart(2, '0');
  const utcSeconds = String(now.getUTCSeconds()).padStart(2, '0');
  return `${utcHours}:${utcMinutes}:${utcSeconds}`;
};


export const formatAdjustmentTime = (value) => {
  if (value === undefined || value === null) return '0';

  const num = Number(value);
  const absoluteValue = Math.abs(num);
  const formattedValue = parseFloat(absoluteValue.toFixed(0));

  return formattedValue.toString();
};

export const formatStopTimer = (seconds) => {
  if (seconds == null) return '';
  const absoluteSeconds = Math.abs(seconds);
  return `${seconds < 0 ? '-' : ''}${Math.floor(absoluteSeconds / 60)}:${String(absoluteSeconds % 60).padStart(2, '0')}`;
};

export const parseStopTimer = (value) => {
  const text = String(value).trim().replace(',', '.');
  const duration = text.match(/^(-?)(\d+):([0-5]\d)$/);
  if (duration) {
    return (Number(duration[2]) * 60 + Number(duration[3])) * (duration[1] ? -1 : 1);
  }
  if (!/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(text)) return NaN;
  return Math.round(Number(text) * 60);
};
